import { render, staticRenderFns } from "./vouchersgetterlist.vue?vue&type=template&id=5284c32c&scoped=true&"
import script from "./vouchersgetterlist.vue?vue&type=script&lang=js&"
export * from "./vouchersgetterlist.vue?vue&type=script&lang=js&"
import style0 from "./vouchersgetterlist.vue?vue&type=style&index=0&id=5284c32c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284c32c",
  null
  
)

export default component.exports